import {useEffect, useRef} from 'react'
import {Tab} from 'bootstrap'
import {
  MenuComponent,
  DrawerComponent,
  ScrollComponent,
  ScrollTopComponent,
  StickyComponent,
  ToggleComponent,
  SwapperComponent,
} from '../assets/ts/components'
import {ThemeModeComponent} from '../assets/ts/layout'

import {useLayout} from './core'

export function MasterInit() {
  const {config} = useLayout()
  const isFirstRun = useRef(true)

  const pluginsInitialization = () => {
    isFirstRun.current = false

    // Critical: Initialize theme immediately
    ThemeModeComponent.init()

    // Defer non-critical components to when browser is idle
    const initializeComponents = () => {
      ToggleComponent.bootstrap()
      ScrollTopComponent.bootstrap()
      DrawerComponent.bootstrap()
      StickyComponent.bootstrap()
      MenuComponent.bootstrap()
      ScrollComponent.bootstrap()
      SwapperComponent.bootstrap()
    }

    // Defer tab initialization even more - only when user interacts
    const initializeTabs = () => {
      const tabs = document.querySelectorAll('[data-bs-toggle="tab"]')
      if (tabs.length > 0) {
        tabs.forEach((tab) => {
          Tab.getOrCreateInstance(tab)
        })
      }
    }

    // Use requestIdleCallback for non-critical work (fallback to setTimeout)
    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => {
        initializeComponents()
        requestIdleCallback(initializeTabs, { timeout: 2000 })
      }, { timeout: 100 })
    } else {
      setTimeout(() => {
        initializeComponents()
        setTimeout(initializeTabs, 100)
      }, 0)
    }
  }

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false
      pluginsInitialization()
    }
  }, [config])

  return <></>
}
